import { DotLottieReact } from "@lottiefiles/dotlottie-react";
import { cva, type VariantProps } from "class-variance-authority";
import { memo } from "react";

import LoadingSrc from "../../../../public/assets/system/loading.lottie?url";

const circleLoadingVariants = cva("block", {
	variants: {
		size: {
			sm: "size-8",
			md: "size-16",
		},
	},
	defaultVariants: {
		size: "md",
	},
});

type Props = VariantProps<typeof circleLoadingVariants>;

export const CircleLoading = memo(({ size }: Props) => {
	return (
		<div>
			<DotLottieReact src={LoadingSrc} loop autoplay className={circleLoadingVariants({ size })} />
		</div>
	);
});

CircleLoading.displayName = "CircleLoading";
